import React, { useState, useEffect } from 'react';
import { getPublicStatusHomeUrl } from '../../../utils/publicStatusPage';
import { 
  ExclamationTriangleIcon
} from '@heroicons/react/24/outline';

const SystemStatusNotification = ({ 
  systemStatus,
  blockingReason,
  isVisible = false
}) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsAnimating(true);
    }
  }, [isVisible]);

  if (!isVisible || !systemStatus?.isActive) {
    return null;
  }

  return (
    <div className={`transition-all duration-300 ease-in-out ${
      isAnimating ? 'transform translate-y-0 opacity-100' : 'transform translate-y-4 opacity-0'
    }`}>
      <div className="bg-white dark:bg-[#181818] border border-gray-200 dark:border-[#282828] rounded-3xl p-4 shadow-lg w-full">
        <div className="flex items-start justify-between">
          <div className="flex items-start gap-3 flex-1">
            <div className="flex-shrink-0 text-gray-500 dark:text-gray-400">
              <ExclamationTriangleIcon className="w-5 h-5" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {systemStatus.title || 'System Status Update'}
              </h3>
              <div className="text-sm text-gray-600 dark:text-gray-300">
                <p>{blockingReason || systemStatus.message}</p>
                <p className="mt-2 font-medium">
                  Chat functionality is temporarily disabled while we resolve this issue.
                </p>
                <p className="mt-1 text-xs opacity-75">
                  View the{' '}
                  <a 
                    href={getPublicStatusHomeUrl()} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="underline hover:no-underline"
                  >
                    status page
                  </a>
                  {' '}for updates.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemStatusNotification;
